var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightDouble({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33085 23.1805C0.678943 22.5286 0.678943 21.4716 1.33085 20.8197L9.96992 12.1806L1.33085 3.54158C0.678943 2.88967 0.678943 1.83273 1.33085 1.18082C1.98275 0.528919 3.0397 0.528919 3.6916 1.18082L13.5111 11.0003C14.163 11.6522 14.163 12.7091 13.5111 13.361L3.6916 23.1805C3.0397 23.8324 1.98275 23.8324 1.33085 23.1805Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9098 23.1805C10.2579 22.5286 10.2579 21.4716 10.9098 20.8197L19.5489 12.1806L10.9098 3.54158C10.2579 2.88967 10.2579 1.83273 10.9098 1.18082C11.5617 0.528918 12.6187 0.528918 13.2706 1.18082L23.09 11.0003C23.7419 11.6522 23.7419 12.7091 23.09 13.361L13.2706 23.1805C12.6187 23.8324 11.5617 23.8324 10.9098 23.1805Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightDouble);
export default __webpack_public_path__ + "static/media/chevron-right-double.b2cf7fd3096e290f3f505cadab528962.svg";
export { ForwardRef as ReactComponent };